import MarketingSection from './marketingSection'

export default MarketingSection



// WEBPACK FOOTER //
// ./client/pages/home/marketingSection/index.tsx